import { kea } from 'kea'
import PropTypes from 'prop-types'
import { put } from 'redux-saga/effects'

import railsContext from 'lib/selectors/rails-context'

import profileController from '../../../profile/public/controller.rb'

export default kea({
  connect: {
    props: [railsContext, ['dpr']]
  },

  actions: () => ({
    loadMore: true,
    friendsLoaded: ({ friends, count }) => ({ friends, count })
  }),

  reducers: ({ actions }) => ({
    localFriends: [
      [],
      PropTypes.array,
      {
        [actions.friendsLoaded]: (_, { friends }) => friends
      }
    ],
    localCount: [
      0,
      PropTypes.number,
      {
        [actions.friendsLoaded]: (_, { count }) => count
      }
    ],
    isLoading: [
      false,
      PropTypes.bool,
      {
        [actions.loadMore]: () => true,
        [actions.friendsLoaded]: () => false
      }
    ]
  }),

  takeEvery: ({ actions, props }) => ({
    [actions.loadMore]: function * () {
      const { friendsLoaded } = this.actions
      const { id } = props
      const response = yield profileController.getAllFriends({ id })
      yield put(friendsLoaded(response))
    }
  })
})
